import {
	FETCH_PRE_PACKAGE_PRICES_FAILURE,
	FETCH_PRE_PACKAGE_PRICES_SUCCESS,
} from "../../actionTypes";
import axios from "axios";
import { getStore } from "app/configureStore";
import env from "app/utils/env";
import { sendTagOnError } from "app/utils/analytics";

export const fetchPrepackagePricesOfCity = (uri, departureCityCode, offerCode, contractType) => {
	return dispatch => {
		const state = getStore().getState();
		const shop = state.shop;
		const endpoint = env("CONTENT_API_URL") || env("BASE_URL");

		const url = `${endpoint}/${state.productsVisibility}/${shop}/${uri}.json`;

		axios
			.get(url)
			.then(res => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_SUCCESS,
					pricesPerDurations: res.data,
					departureCityCode,
					offerCode,
					contractType,
				});
			})
			.catch(err => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_FAILURE,
				});
				sendTagOnError(`Get ${url} : ${err.message} - ${err?.response?.statusText}`);
			});
	};
};

export const fetchPrepackagePricesOfAlternativeCity = (
	uri,
	departureCityCode,
	offerCode,
	contractType
) => {
	return dispatch => {
		const state = getStore().getState();
		const shop = state.shop;
		const endpoint = env("CONTENT_API_URL") || env("BASE_URL");

		const url = `${endpoint}/${state.productsVisibility}/${shop}/${uri}.json`;

		axios
			.get(url)
			.then(res => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_SUCCESS,
					pricesPerDurations: res.data,
					departureCityCode,
					offerCode,
					contractType,
					isAlternativeCity: true,
				});
			})
			.catch(err => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_FAILURE,
				});
				sendTagOnError(`Get ${url} : ${err.message} - ${err?.response?.statusText}`);
			});
	};
};

export const fetchPrepackagePricesOfDurations = (uri, duration, offerCode, contractType) => {
	return dispatch => {
		const state = getStore().getState();
		const shop = state.shop;
		const endpoint = env("CONTENT_API_URL") || env("BASE_URL");
		const url = `${endpoint}/${state.productsVisibility}/${shop}/${uri}.json`;

		axios
			.get(url)
			.then(res => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_SUCCESS,
					pricesPerDurations: res.data,
					duration,
					offerCode,
					contractType,
				});
			})
			.catch(err => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_FAILURE,
				});
				sendTagOnError(`Get ${url} : ${err.message} - ${err?.response?.statusText}`);
			});
	};
};

export const fetchPrepackageAccommodationsOfDuration = (uri, duration, offerCode, contractType) => {
	return dispatch => {
		const state = getStore().getState();
		const shop = state.shop;
		const endpoint = env("CONTENT_API_URL") || env("BASE_URL");

		const url = `${endpoint}/${state.productsVisibility}/${shop}/${uri}.json`;
		return axios
			.get(url)
			.then(res => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_SUCCESS,
					pricesPerDurations: res.data,
					duration,
					offerCode,
					contractType,
				});
			})
			.catch(err => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_FAILURE,
				});
				sendTagOnError(`Get ${url} : ${err.message} - ${err?.response?.statusText}`);
			});
	};
};
